import { RadioStation } from '../types/radio';
import { safeSetItem } from './localStorageHelpers';

const STORAGE_KEYS = {
  LAST_STATION: 'radio_last_station',
  LAST_VOLUME: 'radio_last_volume',
  WAS_PLAYING: 'radio_was_playing'
};

export const saveLastStation = (station: RadioStation | null) => {
  if (station) {
    safeSetItem(STORAGE_KEYS.LAST_STATION, JSON.stringify(station), {
      context: 'storage.saveLastStation',
      onQuotaExceeded: () => {
        console.info('storage.saveLastStation: Clearing cached station after quota exceed.');
        try {
          localStorage.removeItem(STORAGE_KEYS.LAST_STATION);
        } catch (cleanupError) {
          console.warn('storage.saveLastStation: Failed to clear cached station.', cleanupError);
        }
      }
    });
  } else {
    localStorage.removeItem(STORAGE_KEYS.LAST_STATION);
  }
};

export const getLastStation = (): RadioStation | null => {
  const stored = localStorage.getItem(STORAGE_KEYS.LAST_STATION);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      localStorage.removeItem(STORAGE_KEYS.LAST_STATION);
      return null;
    }
  }
  return null;
};

export const savePlaybackState = (volume: number, wasPlaying: boolean) => {
  let hasCleared = false;
  const handleQuotaExceeded = () => {
    if (hasCleared) return;
    hasCleared = true;
    console.info('storage.savePlaybackState: Clearing cached playback state after quota exceed.');
    try {
      localStorage.removeItem(STORAGE_KEYS.LAST_VOLUME);
      localStorage.removeItem(STORAGE_KEYS.WAS_PLAYING);
    } catch (cleanupError) {
      console.warn('storage.savePlaybackState: Failed to clear cached playback state.', cleanupError);
    }
  };

  safeSetItem(STORAGE_KEYS.LAST_VOLUME, volume.toString(), {
    context: 'storage.savePlaybackState',
    onQuotaExceeded: handleQuotaExceeded
  });
  safeSetItem(STORAGE_KEYS.WAS_PLAYING, wasPlaying.toString(), {
    context: 'storage.savePlaybackState',
    onQuotaExceeded: handleQuotaExceeded
  });
};

export const getPlaybackState = () => {
  const volume = parseFloat(localStorage.getItem(STORAGE_KEYS.LAST_VOLUME) || '0.5');
  const wasPlaying = localStorage.getItem(STORAGE_KEYS.WAS_PLAYING) === 'true';
  return { volume, wasPlaying };
};
